import * as React from "react";
import styled from "styled-components";

interface HeaderPositionerProps {
  /** INFORMACJA CZY HEADER MENU JEST PRZYPIĘTU NA STAŁE */
  headerMenuIsSticky: boolean
}

const HeaderPositioner = (props: HeaderPositionerProps) => {
  const {headerMenuIsSticky} = props;
  return <HeaderPositionerWrapper data-header-menu-is-sticky={headerMenuIsSticky} />
};

/** STYLES */

const HeaderPositionerWrapper = styled.div`
  @media (max-width: 600px) {
    height: 10px !important;
  }
  @media (min-width: 601px) and (max-width: 768px) {
    height: 30px !important;
  }
  &[data-header-menu-is-sticky~="true"] {
    height: 63px;
  }
  &[data-header-menu-is-sticky~="false"] {
    height: 102px;
  }
`;

export default HeaderPositioner


// WEBPACK FOOTER //
// ./src/layouts/header/header-positioner.tsx